<template>
  <div id="app">
    <div
      v-if="loading"
      class="d-flex w-100"
      style="height: 100vh"
      v-loading="loading"
      element-loading-text="系統初始化中..."
    ></div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  async created() {
    window.NxVet.setLogLevel("error");
    // window.NxVetV2.setServerHost("http://192.168.20.52:5984");
    // window.NxVetV2.setApiServerHost("http://192.168.20.52:5983");
    // window.NxVet.setApiServerHost("http://192.168.20.52:5983");
    // window.NxErp.setApiServerHost("http://20.210.89.52");
    // window.NxErp.setApiServerHost("http://192.168.20.52:5987");

    // try {
    // await window.NxVet.init();

    // get IP location
    // try {
    //   let res = await this.getIP();
    //   if (res && res.ip) {
    //     let ip = res.ip;
    //     let existIP = localStorage.getItem("LOCAL_IP");
    //     if (!existIP || existIP != ip) {
    //       localStorage.setItem("LOCAL_IP", ip);
    //     }
    //     window.NxErp.saveUserIP("open");
    //     // console.log(existIP);
    //     // console.log("IP out", ip);
    //   }
    // } catch (e) {
    //   console.log("getIP error", e);
    // }

    console.log(
      `%c獸醫HIS系統首選 - NxVet`,
      "color: #00bdd4; font-size: 24px; font-weight: bold;"
    );
    this.loading = false;
    // } catch (error) {
    //   window.NxVetV2.logout();
    //   switch (error.code) {
    //     case 100108:
    //       this.onErrorMsg("該診所已被禁止操作，建議你尋求系統管理員的協助");
    //       break;
    //     default:
    //       this.onErrorMsg(error.message);
    //   }
    //   let _this = this;
    //   setTimeout(() => {
    //     location.reload();
    //   }, 3000);
    // }
  },
  mounted() {
    //disable use wheel to modify number input dom
    document.addEventListener("wheel", function (event) {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    });
  },
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    async getIP() {
      return fetch("https://api.ipify.org?format=json").then((res) => {
        return res.json();
      });
    },
  },
};
</script>
